import "./index.css";
import "./assets/fonts/fonts.css";

const container = document.getElementById("root");

async function start() {
  if (!container) return;
  await document.fonts.ready;
  // Load interactive code after the entry stylesheet, so it cannot compete
  // with the CSS needed to display the already prerendered article.
  const [{ createElement }, { hydrateRoot, createRoot }, { default: App }, { loadMarkdown }, { posts }, { BASE_PATH }] = await Promise.all([
    import('react'),
    import('react-dom/client'),
    import('./App'),
    import('./lib/markdown-modules-client'),
    import('./lib/data/posts'),
    import('./lib/site'),
  ]);
  const pathname = window.location.pathname.slice(BASE_PATH === '/' ? 0 : BASE_PATH.length - 1);
  const slug = pathname.match(/^\/insights\/([^/]+)\/?$/)?.[1];
  // Preserve the prerendered article while fetching only its Markdown for hydration.
  await loadMarkdown(posts.find((post) => post.slug === slug)?.contentFile);
  const hasServerMarkup = container.firstElementChild !== null;
  // Query-string routes are not prerendered separately. Render them on the
  // client so search/filter results do not conflict with the static HTML.
  const hasQueryString = window.location.search.length > 0;
  if (hasServerMarkup && !hasQueryString) {
    hydrateRoot(container, createElement(App));
  } else {
    createRoot(container).render(createElement(App));
  }
}

// Give the browser a paint opportunity for static content before hydration
// downloads contend with its stylesheet and fonts. No timer or device detection.
requestAnimationFrame(() => requestAnimationFrame(() => {
  void start().catch((error: unknown) => {
    // Keep readable static markup and native navigation if the content request fails.
    console.error('Unable to load article content for hydration. Reload to retry.', error);
  });
}));
